module.exports = __webpack_public_path__ + "static/media/logo-hmi-blue.c65ea97a.png";